import { CREATE_PREVIEW_IMAGES, CLEAR_PREVIEW_IMAGES } from "../actions/types";
const imgSrc = require("../images/950x350-ucla-blue-solid-color-background.jpg");

const initialState = [
  {
    headline: "Headline",
    description: "Description",
    businessName: "Business name",
    selectedImage: { url: imgSrc },
    selectedLogo: { url: "" }
  }
];

export default function(state = initialState, action) {
  let previewImages = [];

  switch (action.type) {
    case CREATE_PREVIEW_IMAGES:
      var {
        headlines,
        descriptions,
        businessName,
        croppedImages,
        croppedLogos
      } = action.payload;

      if (croppedImages.length === 0)
        croppedImages[0] = {
          url: imgSrc
        };
      if (croppedLogos.length === 0)
        croppedLogos[0] = {
          url: ""
        };
      croppedImages.forEach(selectedImage => {
        croppedLogos.forEach(selectedLogo => {
          headlines.forEach(headline => {
            descriptions.forEach(description => {
              previewImages.push({
                selectedImage,
                selectedLogo,
                headline,
                description,
                businessName: businessName[0]
              });
            });
          });
        });
      });
      return previewImages;

    case CLEAR_PREVIEW_IMAGES:
      previewImages = [
        {
          headline: "Headline",
          description: "Description",
          businessName: "Business name",
          selectedImage: { url: imgSrc },
          selectedLogo: { url: "" }
        }
      ];
      return previewImages;

    default:
      return state;
  }
}
